<template>
    <div style="height: 100%;">
        <DefaultPageComponent
        :loading="loading"
        :title="'Parâmetros do Sistema'"
        :haveBackButton="true"
        @onBack="$router.push({name: 'dashboard'})"
        :haveContentMargin="true"
        >

        <!-- CONTENT -->
        <b-col class="p-4" style="border-radius:10px; border: 1px solid #535252;">
            <b-row class="m-0 pb-3">
                <span style="font-size:18px; font-weight:500;">Data de Referência</span>
            </b-row>
            <p style="color: #a0a0a0; margin-bottom: 20px;">
                Configure a data de referência utilizada pelos jobs de processamento do sistema.
            </p>
            <b-row class="m-0">
                <b-col cols="12" md="4" class="px-0">
                    <InputDatePicker
                        inputId="inputReferenceDate"
                        label="Data de Referência"
                        placeholder="Selecione a data"
                        :value="systemParameter.reference_date"
                        @input="systemParameter.reference_date = $event"
                        :disabled="loading"
                    />
                </b-col>
            </b-row>
        </b-col>

        <template #footer>
            <div class="mx-0 row d-flex align-items-center justify-content-end mx-0 mt-3">
                <CancelButton
                    @click="$router.push({ name: 'dashboard' })"
                >
                    Cancelar
                </CancelButton>
                <CustomButton
                    :loading="loading"
                    type="button"
                    @click="onSubmit"
                    :disabled="!systemParameter.reference_date"
                >
                    Salvar
                </CustomButton>
            </div>
        </template>

        </DefaultPageComponent>
    </div>
</template>

<script>
import DefaultPageComponent from '@/components/DefaultPageComponent.vue';
import CustomButton from '@/components/CustomButton.vue';
import CancelButton from '@/components/CancelButton.vue';
import InputDatePicker from '@/components/InputDatePicker.vue';
import { mapState } from 'vuex';

export default {
    name: 'SystemParametersView',
    components:{
        DefaultPageComponent,
        CustomButton,
        CancelButton,
        InputDatePicker,
    },
    created() {
        this.$validator.localize('en', {
            custom: {
                inputReferenceDate: {
                    required: 'Campo obrigatório.',
                },
            },
        });
    },
    mounted() {
        this.getSystemParameter();
    },
    computed: {
        ...mapState('user', {
            user: (state) => state.user,
        }),
    },
    data() {
        return {
            loading: false,
            systemParameter: {
                id: null,
                reference_date: '',
            },
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
        }
    },
    methods: {
        getSystemParameter() {
            this.loading = true;
            this.$axios.get('system-parameters').then((response) => {
                this.systemParameter = response.data.data;
            }).catch(() => {
                this.$swal({
                    title: 'Erro',
                    text: 'Não foi possível consultar os parâmetros do sistema.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#C44C30',
                    allowOutsideClick: false,
                });
            })
            .finally(() => {
                this.loading = false;
            });
        },
        onSubmit() {
            this.$validator.validateAll().then((result) => {
                if (!result) {
                    return;
                }
                this.loading = true;
                this.$axios.put('system-parameters', {
                    reference_date: this.systemParameter.reference_date,
                }).then(() => {
                    this.$swal({
                        title: 'Sucesso',
                        text: 'Parâmetros do sistema atualizados com sucesso.',
                        icon: 'success',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#28A745',
                        allowOutsideClick: false,
                        focusConfirm: false,
                        customClass: {
                            confirmButton: 'custom-confirm-button-class',
                        }
                    });
                    this.getSystemParameter();
                }).catch(() => {
                    this.$swal({
                        title: 'Erro',
                        text: 'Não foi possível atualizar os parâmetros do sistema.',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#C44C30',
                        allowOutsideClick: false,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
            });
        }
    },
}
</script>

<style scoped>
.form-control {
    background-color: #262625 !important;
    border: 1px solid #535252 !important;
    color: #E5E2E1 !important;
    border-radius: 10px !important;
}
</style>
